import resourcesEn from './resoursesEn';
import resourcesRu from './resoursesRu';

export const resources = {
  ru: resourcesRu,
  en: resourcesEn,
};
